const tabList = [
            {
              lable:'Home',
              name:"first"
          },
          {
              lable:'Travel',
              name:"second"
          },
          {
              lable:'Experience',
              name:"third"
          },
          {
              lable:'About Us',
              name:"fourth"
          },
          {
              lable:'Move Now',
              name:"fifth"
          },
        ]
const selectBoxList = [
    {
        id:1,
        lable:'Accommodations',
    },
    {
        id:2,
        lable:'Traffic',
    },
    {
        id:3,
        lable:'Activities',
    },
    {
        id:4,
        lable:'Services',
    },

]
export default{
    tabList,selectBoxList
}